import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="text-xl font-bold font-heading cursor-pointer hover:text-primary-400 transition-colors">
                男同网
              </Link>
              <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
                专为男同群体打造的综合性平台，提供交友、社群、资讯、健康与活动服务。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">
                <a href="#footer-categories" className="cursor-pointer">分类导航</a>
              </h4>
              <div className="flex flex-col gap-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">快速链接</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
                <Link to="/category/huodong" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">活动资讯</Link>
                <Link to="/category/xinli" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">心理成长</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">关注我们</h4>
              <p className="text-sm text-foreground-300 mb-3">
                微信公众号：nantongwang
              </p>
              <p className="text-sm text-foreground-300">
                邮箱：contact@nantong.wang
              </p>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} 男同网 - 版权所有
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-400">
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">用户协议</a>
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">社区规范</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}